import React from "react";
import { CheckIcon } from "lucide-react";
import { useSeo } from "../../hooks/useSeo";
import { useInboxForm } from "../../hooks/useFormStatus";
import { PageHero } from "../../components/ui/PageHero";
import { CtaBand } from "../../components/ui/CtaBand";
import { Reveal } from "../../components/ui/Reveal";
import { Field, inputCls } from "../../components/forms/Field";
import { FormError, FormSuccess, SubmitButton } from "../../components/forms/FormFeedback";
import { CHECKLIST_PREVIEW } from "../../data/resources";
const BUSINESS_TYPES = ["Small business", "Restaurant", "Automotive", "Contractor / service provider", "Personal brand", "E-commerce", "Portfolio", "Other"];
export function WebsiteChecklist() {
  const {
    status,
    onSubmit,
    reset
  } = useInboxForm("Website checklist request");
  useSeo({
    title: "Free Website Checklist",
    description: "Download the free NEXORA website checklist: everything to prepare before you build your business website.",
    path: "/resources/website-checklist"
  });
  return <>
      <PageHero crumbs={[{
      label: "Resources",
      href: "/resources"
    }, {
      label: "Website Checklist"
    }]} eyebrow="Free download" title="The website checklist." lead="Everything to gather before you build — so your project starts faster and nothing gets missed." data-id="element-881" data-mp="244qbsldnk4eq" />
      <section className="shell section grid gap-[clamp(2.5rem,5vw,7rem)] lg:grid-cols-[1fr_1fr]" data-id="element-882" data-mp="288xykd0jvaab">
        <Reveal data-id="element-883" data-mp="1kitxacau3mmh">
          <h2 className="t-h3" data-id="element-884" data-mp="1kg7ok9c7j12o">What's inside</h2>
          <ul className="mt-6 border-t border-line" data-id="element-885" data-mp="1gi08zhthc5t2">
            {CHECKLIST_PREVIEW.map(item => <li key={item} className="flex min-h-[60px] items-center gap-3 border-b border-line text-fg-2" data-id="element-886" data-mp="1u95e2zfm9qas">
                <CheckIcon className="h-5 w-5 shrink-0 text-accent-soft" aria-hidden data-id="element-887" data-mp="1pg3wgjo0zcni" />{item}
              </li>)}
          </ul>
        </Reveal>
        <Reveal delay={0.05} data-id="element-888" data-mp="wt9go025l1gd">
          {status === "success" ? <FormSuccess title="Your checklist is on its way." text="Thanks! We'll email the checklist to the address you entered. Keep an eye on your inbox (and spam folder)." action={<button type="button" onClick={reset} className="min-h-[44px] text-fg-2 underline underline-offset-4 hover:text-fg" data-id="element-890" data-mp="36l27knt8qnrj">Request for another email</button>} data-id="element-889" data-mp="wqwv7cx6s8yk" /> : <form onSubmit={onSubmit} className="grid gap-5 rounded-[clamp(1rem,1.5vw,1.75rem)] border border-line bg-ink-2 p-[clamp(1.5rem,3vw,3.5rem)]" data-id="element-891" data-mp="3blydt812em04">
              <h2 className="t-h3" data-id="element-892" data-mp="2iw9a2mwz07ut">Get the free checklist</h2>
              <Field label="Name" htmlFor="cl-name" data-id="element-893" data-mp="2nusyqv2y7xqv"><input id="cl-name" name="name" required autoComplete="name" className={inputCls} data-id="element-894" data-mp="2ntrm4m6ab371" /></Field>
              <Field label="Email" htmlFor="cl-email" data-id="element-895" data-mp="2rxpk2tjvi7yi"><input id="cl-email" name="email" type="email" required autoComplete="email" className={inputCls} data-id="element-896" data-mp="34byu169xwm5" /></Field>
              <Field label="Business type" htmlFor="cl-type" data-id="element-897" data-mp="75dwweogg2mj">
                <select id="cl-type" name="business_type" required defaultValue="" className={inputCls} data-id="element-898" data-mp="77rscon1rgum">
                  <option value="" disabled data-id="element-899" data-mp="1rpsislw44lmx">Select one</option>
                  {BUSINESS_TYPES.map(b => <option key={b} data-id="element-900" data-mp="1nogzey3u0wn6">{b}</option>)}
                </select>
              </Field>
              <label className="flex items-start gap-3 text-[15px] text-muted" data-id="element-901" data-mp="1itjkjajvft2d">
                <input type="checkbox" name="newsletter_opt_in" value="yes" className="mt-1 h-5 w-5 accent-[#0A57FF]" data-id="element-902" data-mp="1dw1j0586og4e" />
                Also send me occasional website tips.
              </label>
              {status === "error" && <FormError data-id="element-903" data-mp="140hq7rox1xjv" />}
              <SubmitButton status={status} data-id="element-904" data-mp="zwic1fr3zato">Send me the checklist</SubmitButton>
            </form>}
        </Reveal>
      </section>
      <CtaBand source="checklist" data-id="element-905" data-mp="uz0cgfyze7yc" />
    </>;
}